import { jsx as o } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { getCapitalErrorMessage as l } from "../../../../utils/capital/getCapitalErrorMessage.js";
import s from "../../../../../core/Errors/AdyenPlatformExperienceError.js";
import { ErrorMessageDisplay as u } from "../../../../internal/ErrorMessageDisplay/ErrorMessageDisplay.js";
import { useCallback as E, useMemo as g } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import C from "../../../../internal/Button/Button.js";
import { ButtonVariant as R } from "../../../../internal/Button/types.js";
import c from "../../../../../core/Context/useCoreContext.js";
import { ErrorTypes as m } from "../../../../../core/Http/utils.js";
import { Fragment as d } from "../../../../../external/preact/dist/preact.module.js";
const h = ({
  emptyGrantOffer: t,
  error: e,
  onContactSupport: i,
  onBack: r,
  unsupportedRegion: n
}) => {
  const { i18n: a } = c(), p = E(
    () => /* @__PURE__ */ o(d, { children: r && /* @__PURE__ */ o(C, { variant: R.SECONDARY, onClick: r, children: a.get("back") }) }),
    [a, r]
  ), f = g(() => n ? new s(m.ERROR, "UnsupportedRegion", "Unsupported Region Configuration", "UNSUPPORTED_REGION") : t ? new s(m.ERROR, "EmptyConfig", "Empty Configuration", "EMPTY_CONFIG") : e, [t, n, e]);
  return /* @__PURE__ */ o(
    u,
    {
      absolutePosition: !1,
      withImage: !0,
      onContactSupport: i,
      renderSecondaryButton: p,
      outlined: !1,
      ...l(f, i)
    }
  );
};
export {
  h as CapitalErrorMessageDisplay
};
